<template>
  <v-card>
    <v-card-title primary-title>
      <h3 class="headline mb-0">Login</h3>
    </v-card-title>

    <v-card-text v-if="showError">
      <v-alert
      v-model="showError"
      type="error"
      icon="warning"
      dismissible>
        {{ errorMessage }}
      </v-alert>
    </v-card-text>

    <v-card-text v-if="showInfo">
      <v-alert
      v-model="showInfo"
      type="info"
      icon="info"
      dismissible>
        {{ infoMessage }}
      </v-alert>
    </v-card-text>

    <v-card-text>
      <v-form @submit.prevent="validateLogin">

        <v-text-field
        label="E-mail"
        v-model="email"
        type="email"
        :error-messages="emailErrors"
        @input="$v.email.$touch()"
        @blur="$v.email.$touch()"
        required
        ></v-text-field>

        <v-text-field
        v-if="!forgotPassword"
        label="Password"
        v-model="password"
        :type="showPassword ? 'text' : 'password'"
        :error-messages="passwordErrors"
        @input="$v.password.$touch()"
        @blur="$v.password.$touch()"
        required
        hint="At least 8 characters"
        counter
        :append-icon="showPassword ? 'visibility_off' : 'visibility'"
        @click:append="showPassword = !showPassword"
        ></v-text-field>

      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn
      v-if="!forgotPassword"
      :loading="isUpdatingUser"
      :disabled="isUpdatingUser"
      @click="forgotPassword = true; showError = false"
      color="primary"
      >
        Forgot password
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn
      v-if="!forgotPassword"
      :loading="isUpdatingUser"
      :disabled="isUpdatingUser"
      @click="validateLogin"
      color="primary"
      >
        login
      </v-btn>

      <v-btn
      v-if="forgotPassword"
      :loading="isUpdatingUser"
      :disabled="isUpdatingUser"
      @click="forgotPassword = false"
      color="primary"
      >
        Cancel
      </v-btn>
      <v-btn
      v-if="forgotPassword"
      :loading="isUpdatingUser"
      :disabled="isUpdatingUser"
      @click="validateResetPassword"
      color="primary"
      >
        Reset password
      </v-btn>

    </v-card-actions>
    <!--
    <v-slide-y-transition>
      <v-card-text v-show="show">
        fdsgfdsgfd
      </v-card-text>
    </v-slide-y-transition>
    -->
  </v-card>
</template>

<script>
// import { auth } from '@/firebase.js';
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapActions } = createNamespacedHelpers('auth')
import { validationMixin } from 'vuelidate';
import {
  required,
  email,
  minLength
  // maxLength
} from 'vuelidate/lib/validators'

export default {
  name: 'LoginCard',

  mixins: [ validationMixin ],

  data() {
    return {
      debug: false,

      email: '',
      password: '',
      showPassword: false,

      forgotPassword: false,

      showError: false,
      errorMessage: '',

      showInfo: false,
      infoMessage: ''
    }
  },

  props: {},

  validations: {
    email: { required, email },
    password: { required, minLength: minLength(8) }
  },

  watch: {},

  computed: {
    ...mapState({
      isUpdatingUser: state => state.isUpdatingUser, // map `this.user` to `this.$store.state.users.isUpdatingUser`
    }),

    emailErrors() {
      const errors = [];
      if (this.$v.email.$dirty) {
        !this.$v.email.email && errors.push('Must be valid e-mail');
        !this.$v.email.required && errors.push('E-mail is required');
      }
      return errors;
    },

    passwordErrors() {
      const errors = [];
      if (this.$v.password.$dirty) {
        !this.$v.password.minLength && errors.push('Password must be at least 8 characters long');
        !this.$v.password.required && errors.push('Password is required');
      }
      return errors;
    }
  },

  methods: {
    ...mapActions([
      'loginUserWithProvider', // map `this.loginUserWithProvider(providerName)` to `this.$store.dispatch('users/loginUserWithProvider', providerName)`
      'resetUserPassword' // map `this.resetUserPassword(email)` to `this.$store.dispatch('users/resetUserPassword', email)`
    ]),

    clearForm () {
      this.$v.$reset();
      this.email = null;
      this.password = null;
    },

    validateLogin () {
      if (this.debug) console.log(this.$options.name+'.validateLogin()');
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.login();
      }
      else {
        this.errorMessage = 'Fill form fields correctly';
        this.showError = true;
      }
    },

    login () {
      if (this.debug) console.log(this.$options.name+'.loginWithProvider()')
      let providerData = {email: this.email, password: this.password}
      this.loginUserWithProvider({ providerName: 'password', providerData })
      .then(() => {
        if (this.debug) console.log(this.$options.name+'.loginWithProvider() provider removed');
        this.showError = false;
      })
      .catch((error) => {
        if (this.debug) console.log(this.$options.name+'.loginWithProvider() error:',error);
        this.errorMessage = error
        if (error.code === 'auth/wrong-password') this.errorMessage += '\nMaybe you has logged with a provider like Google or Facebook.';
        else if (error.code === 'auth/user-not-found') this.errorMessage += '\nPlease, check that the email is correctly written. If you are a new user, you are looking for a register: click on "REGISTER NEW ACCOUNT" button on top right.';
        else if (error.message) this.errorMessage = error.message
        else this.errorMessage = error
        this.showError = true
      })
    },

    validateResetPassword () {
      if (this.debug) console.log(this.$options.name+'.validateResetPassword() $v.email:',this.$v.email);
      this.$v.email.$touch();
      if (!this.$v.email.$invalid) {
        this.resetPassword();
      }
      else {
        this.errorMessage = 'Check email field';
        this.showError = true;
      }
    },

    resetPassword () {
      if (this.debug) console.log(this.$options.name+'.resetPassword()')
      this.resetUserPassword(this.email)
      .then(() => {
        if (this.debug) console.log(this.$options.name+'.resetPassword() email sent.')
        this.infoMessage = 'An email was sent to your email. Click on the link in the email to reset the password and next login again.'
        this.showError = false
        this.showInfo = true
        this.forgotPassword = false
      })
      .catch((error) => {
        if (this.debug) console.log(this.$options.name+'.resetPassword() sending email error:',error)
        this.errorMessage = error.message
        this.showError = true
      });
    }
  }
}
</script>

<style scoped>  /* "scoped" attribute limit the CSS to this component only */
</style>